import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private showFeedbackModalSubject = new BehaviorSubject<boolean>(false);
  public showFeedbackModal$ = this.showFeedbackModalSubject.asObservable();

  openFeedbackModal(): void {
    this.showFeedbackModalSubject.next(true);
  }

  closeFeedbackModal(): void {
    this.showFeedbackModalSubject.next(false);
  }

  toggleFeedbackModal(): void {
    this.showFeedbackModalSubject.next(!this.showFeedbackModalSubject.value);
  }

  get isOpen(): boolean {
    return this.showFeedbackModalSubject.value;
  }
}
